<template>
  <div class="pay mt40">
    <!-- 订单支付 -->
    <div class="pay-wrap">
      <div class="title">订单支付</div>
      <div class="pay-info">
        <div class="left">
          <img class="success" src="../../assets/images/success.png" alt="">
          <div class="text-info">
            <div class="result">订单提交成功，只差付款了~</div>
            <div class="tip">支付时间剩余  <span>{{rocallTime}}</span> ，超时订单可能会被取消</div>
          </div>
        </div>
        <div class="right">
            <div>订单金额: <span class="amount">¥{{orderInfo.paymentTotal}}</span></div>
            <div class="for-detail" @click="showDetail = !showDetail">订单详情
              <img v-if="showDetail" src="../../assets/images/up.png" alt="">
              <img v-else src="../../assets/images/down.png" alt="">
            </div>
          </div>
      </div>
      <div class="order-detail" :class="showDetail ? 'show' : ''">
        <div class="line">
          <div class="part">
            <span class="label">订单编号</span>
            <span class="cont">{{orderInfo.uniteOrderNo}}</span>
          </div>
          <div class="part">
            <span class="label">订单状态</span>
            <span class="cont">{{orderInfo.statusName}}</span>
          </div>
        </div>
        <div class="line">
          <div class="part">
            <span class="label">下单时间</span>
            <span class="cont">{{orderInfo.createdDate}}</span>
          </div>
          <div class="part">
            <span class="label">联系号码</span>
            <span class="cont">{{orderInfo.phone || '暂无'}}</span>
          </div>
        </div>
      </div>
      <!-- <div class="pay-way">
        <div class="til">支付方式</div>
        <div class="pay-way-list">
          <span class="label">请选择支付方式:</span>
          <el-radio-group v-model="payWay">
            <el-radio :label="3"><img class="wx-pay" src="../../assets/images/wx-pay.png" alt="">微信支付</el-radio>
            <el-radio :label="6"><img class="ali-pay" src="../../assets/images/ali-pay.png" alt="">支付宝支付</el-radio>
            <el-radio :label="9"><img class="card-pay" src="../../assets/images/card-pay.png" alt="">银联支付</el-radio>
          </el-radio-group>
        </div>
      </div> -->
      <div class="pay-btn">
        <el-button class="red-btn" @click="handlePay">立即支付</el-button>
      </div>
    </div>

    <!-- 支付弹框 -->
    <payDialog ref="payDialog" :from="from" />
  </div>
</template>

<script>
import { orderInfo, getSysTime } from '@/api/pay'
import PayDialog from '@/components/payDialog'
import { formatDate } from '@/utils/validate'
export default {
  data () {
    return {
      orderInfo: {},
      payWay: null,
      showDetail: true,
      time: 29,
      min: 59,
      from: null,
      rocallTime: null
    }
  },
  computed: {
  },
  components: {
    'payDialog': PayDialog
  },
  created () {
    this.orderNo = this.$route.query.orderNo
    this.from = this.$route.query.from
    this.getOrderInfo()
  },
  beforeDestroy () {
    clearInterval(this.countTime)
  },
  methods: {
    handlePay () {
      this.$refs.payDialog.toPay(this.orderNo, 'RETAIL')
    },
    getOrderInfo () {
      orderInfo(this.orderNo, 'RETAIL', this.from).then(res => {
        if (res.code === 0) {
          if (this.from === 'cart') {
            this.orderInfo = res.data[0]
          } else {
            this.orderInfo = res.data
          }
          res.data.bookDate = formatDate('yyyy-MM-dd', new Date())
          this.getSysTime(this.orderInfo.expire)
        }
      })
    },
    getSysTime (expire) {
      getSysTime().then(res => {
        if (res.code === 0 && res.data && res.data.sysTime) {
          // 支付倒计时
          const ts = new Date(expire.replace(/-/g, '/')).getTime()
          const tc = new Date(res.data.sysTime.replace(/-/g, '/')).getTime()
          this.runBack(ts - tc)
        } else {
          const ts = new Date(expire.replace(/-/g, '/')).getTime()
          const tc = new Date().getTime()
          this.runBack(ts - tc)
        }
      })
    },
    runBack (cm) {
      const minutes = new Date(cm).getMinutes()
      const seconds = new Date(cm).getSeconds()
      if (cm > 0) {
        // 超过60秒，展示分秒
        if (cm > 60000) {
          const m = minutes < 10 ? '0' + minutes : minutes
          const s = seconds < 10 ? '0' + seconds : seconds
          this.rocallTime = m + '分' + s + '秒'
        } else {
          // 只展示秒
          const s = seconds < 10 ? '0' + seconds : seconds
          this.rocallTime = s + '秒'
        }
        setTimeout(() => {
          cm -= 1000
          this.runBack(cm)
        }, 1000)
      } else {
        // 取消订单
        this.$refs.payDialog.cancelOrder(this.orderNo, 'RETAIL')
      }
    }
  }
}
</script>
<style scoped lang='scss'>
.pay {
  .pay-wrap {
    max-width: 1279px;
    padding: 40px;
    overflow-x: auto;
    width: 1279px;
    background: #FFFFFF;
    box-shadow: 0px 3px 16px rgba(24, 60, 80, 0.08);
    border-radius: 8px;
    .title {
      padding-bottom: 40px;
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      line-height: 36px;
      color: #9B232A;
      border-bottom: 1px solid #8FA8BC;
    }

    .pay-info {
      display: flex;
      margin-top: 36px;
      align-items: center;
      justify-content: space-between;

      .left {
        img.success {
          display: inline-block;
          width: 72px;
          height: 72px;
        }

        .text-info {
          display: inline-block;
          margin-left: 14px;
          vertical-align: top;
          transform: translateY(6px);

          .result {
            margin-bottom: 8px;
            font-size: 20px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #74C148;
          }
          .tip {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #424855;
            span {
              color: #FF0000;
            }
          }
        }
      }

      .right {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #687280;
        .amount {
          font-size: 28px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #FF0000;
          vertical-align: bottom;
        }
        .for-detail {
          margin-top: 8px;
          text-align: right;
          cursor: pointer;
          img {
            margin-left: 3px;
            transform: translateY(3px);
          }
        }
      }
    }

    .order-detail {
      display: none;
      margin-top: 18px;
      padding: 25px 0 25px 86px;
      background: #F5F5F5;
      &.show {
        display: block;
      }

      .line {
        display: flex;
        align-items: center;
        .part {
          margin-bottom: 12px;
          .label {
            margin-right: 30px;
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            line-height: 24px;
            color: #9FA1B0;
          }
          .cont {
            display: inline-block;
            min-width: 185px;
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            line-height: 24px;
            color: #44516F;
          }
          &:first-child {
            margin-right: 80px;
          }
        }
      }
    }

    .pay-way {
      .til {
        margin-top: 60px;
        margin-bottom: 14px;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        line-height: 26px;
        color: #424855;
      }

      .pay-way-list {
        .label {
          margin-right: 28px;
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #424855;
        }

        .el-radio-group {
          img {
            width: 28px;
            height: 28px;
            margin-right: 8px;
            margin-left: 9px;
            vertical-align: middle;
          }
        }
      }
    }

    .pay-btn {
      margin-top: 328px;
      text-align: right;
    }
  }
}
</style>
